{
	"accounts": "Konta",
	"invitations": "Zaproszenia",
	"subscribeToFeedback": "Zapisz się do programu opinii",
	"notificationSettings": {
		"title": "Ustawienia powiadomień e-mail",
		"invoicingInformation": "Informacje o fakturowaniu",
		"declarationProcessingStatus": "Status przetwarzania deklaracji",
		"enabled": "Wł.",
		"disabled": "Wył.",
		"toast": {
			"success": "Preferencja powiadomień została zaktualizowana",
			"error": "Nie udało się zaktualizować preferencji powiadomień"
		}
	},
	"about": {
		"title": "Informacje",
		"termsAndConditions": "Regulamin",
		"privacyPolicy": "Polityka prywatności",
		"imprint": "Informacje prawne",
		"openSourceAttribution": "Informacje o oprogramowaniu open source"
	},
	"language": {
		"title": "Język",
		"footer": "Zmiany języka zostaną zastosowane we wszystkich aplikacjach Heidelberg Materials"
	},
	"impressum": "Informacje prawne",
	"copyright": "© 2024 Heidelberg Materials. Wszelkie prawa zastrzeżone.",
	"login": "Zaloguj się",
	"logout": "Wyloguj się"
}
